import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function AccessDenied() {
    const { logout } = useAuth();

    return (
        <div className="container d-flex justify-content-center align-items-center flex-column mt-5">
            <h1>Access Denied</h1>
            <p>You do not have permission to access this page.</p>

            <div className="access-denied-actions">
                <Link to="/dashboard" className="btn btn-primary mx-2">
                    Go to Dashboard
                </Link>

                <a onClick={logout} href="/login" className="btn btn-outline-secondary mx-2">
                    Sign Out
                </a>
            </div>
        </div>
    );
}

export default AccessDenied;